// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1997":"9dac5e1d","2969":"f7a5fa08","8244":"f7a5fa08","8396":"f7a5fa08","8936":"cfdc2f12","8944":"40a98cd7"}[chunkId] + ".chunk.css";
};